var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8003 35.7676C13.7634 35.7307 13.6879 35.6341 13.6079 35.4209C13.5271 35.2053 13.4996 35.0345 13.4995 34.9014V34.4736L15.2954 27.374L15.689 25.8174L4.99951 25.8174C4.46395 25.8173 3.99823 25.6315 3.55029 25.1836C3.10238 24.7356 2.9165 24.27 2.9165 23.7344V20.4014C2.9165 20.2956 2.92792 20.1648 2.95752 20.0068C2.98346 19.8685 3.02104 19.7483 3.06592 19.6436L3.06689 19.6406L8.06201 7.90332C8.20263 7.59658 8.44676 7.29982 8.85986 7.02441C9.25858 6.7586 9.63141 6.65143 9.99951 6.65137H25.4165L25.4165 26.5498L14.9995 36.9668L13.8003 35.7676ZM31.2495 25.8174L31.2495 6.65137H35.4165L35.4165 25.8174H31.2495Z",
    fill: "#DFE3E8",
    stroke: "#DFE3E8",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/Dislike.8e304b46518a7f678e831839a385eee5.svg";
export { ForwardRef as ReactComponent };